export default "__VITE_ASSET__91af89f6__"